<template>
  <section v-if="personalNotifications.length" class="mb-6">
    <h4
      class="mx-6 md:mx-[32px] lg:mx-[56px] mb-[4px] md:mb-3 text-[18px] leading-[24px] font-aktiv-grotesk font-bold text-grey-100"
    >
      Notifications
    </h4>
    <div v-for="n in personalNotifications" :key="n.id" class="mx-6 md:mx-[32px] lg:mx-[56px]">
      <div
        class="mt-3 md:mt-0 bg-white border border-1 border-grey-10 rounded-xl p-3 pr-7 mb-3 relative overflow-hidden text-[16px] leading-[24px]"
      >
        <div
          class="cursor-pointer"
          data-test-id="gensapp-personalnotification-open"
          @click="open(n)"
        >
          <div class="flex items-start gap-3">
            <div class="min-w-0 flex-1 font-aktiv-grotesk">
              <p class="font-aktiv-grotesk-medium text-grey-100 tracking-wide">{{ n.title }}</p>
              <div
                class="personal-body mt-1 tracking-wide text-[16px] leading-[24px] text-grey-100 font-aktiv-grotesk"
              >
                <html-to-vue :html="n.bodyHtml || n.body" />
              </div>
            </div>
          </div>

          <div class="flex justify-end font-aktiv-grotesk mt-2">
            <p class="tracking-wide text-xs text-grey-100">
              {{ formatPostedTime(n.createdAt) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import momentts from 'moment-timezone';
import { mapState } from 'vuex';

export default {
  name: 'PersonalNotifications',
  computed: {
    ...mapState('announcements', ['personalNotifications']),
    todayText() {
      return this.$t('copy.announcementPage.announcementCard.today');
    },
  },
  methods: {
    open(n) {
      if (n.route) this.$router.push(n.route);
    },
    formatPostedTime(time) {
      if (!time) return '';
      momentts.tz.setDefault('Asia/Singapore');
      const currentDate = momentts();
      const postedDate = momentts(time);
      const currentLocale = this.$i18n.locale;
      let formattedDate = '';
      let formattedTime = '';

      // Date portion
      if (currentDate.isSame(postedDate, 'day')) {
        formattedDate = `${this.todayText}`;
      } else if (currentLocale === 'zh') {
        formattedDate = new Intl.DateTimeFormat('zh-CN', {
          month: 'long',
          day: 'numeric',
        }).format(postedDate);
      } else if (currentLocale === 'th') {
        formattedDate = new Intl.DateTimeFormat('th-TH', {
          month: 'long',
          day: 'numeric',
        }).format(postedDate);
      } else {
        formattedDate = postedDate.format('DD MMM,').toUpperCase();
      }

      // Time portion
      if (currentLocale === 'th') {
        formattedTime =
          new Intl.DateTimeFormat('th-TH', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false,
          }).format(postedDate) + ' น';
      } else {
        formattedTime = new Intl.DateTimeFormat('en', {
          hour: 'numeric',
          minute: 'numeric',
          hour12: true,
        }).format(postedDate);
      }

      return formattedDate + ' ' + formattedTime;
    },
  },
};
</script>

<style scoped>
/* Match the announcement card's rich-text styling (AnncCard.vue) so CMS-style
   HTML bodies render consistently: links, bold, and paragraph spacing. */
.personal-body :deep(a) {
  color: #00aae4;
  font-weight: 600;
  text-decoration: underline;
}
.personal-body :deep(strong) {
  font-weight: 700;
}
.personal-body :deep(p) {
  margin: 0;
}
.personal-body :deep(p + p) {
  margin-top: 0.5rem;
}
</style>
